import gsap from "gsap/gsap-core";
import React from "react";
import curation from "../webgl/data/curation";

import "./artist-modal.css";

class ArtistModal extends React.PureComponent {
  componentDidMount() {
    gsap.set(this.container, { autoAlpha: this.props.visible ? 1 : 0 });
    gsap.set(this.artwork, { autoAlpha: this.props.visible ? 1 : 0 });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.animate(this.props.visible);
    }
  }

  animate(visible) {
    if (visible) {
      this.image = new Image();

      gsap.set(this.artwork, { autoAlpha: 0 });

      const data = this.getData();

      this.image.onload = () => {
        gsap.to(this.artwork, { autoAlpha: 1 });
      };

      this.image.src = data.artwork;
    }
    gsap.to(this.container, {
      autoAlpha: visible ? 1 : 0,
      onComplete: () => {
        this.background.style.pointerEvents = visible ? "inherit" : "none";

        if (!visible) {
          gsap.set(this.artwork, { autoAlpha: 0 });
        }
      },
    });
  }

  onCloseClick = () => {
    this.props.onClose();
  };

  getData() {
    let data;
    for (let i = 0; i < curation.curation.artists.length; i++) {
      if (curation.curation.artists[i].objktID === this.props.objktID) {
        data = curation.curation.artists[i];
      }
    }
    return data;
  }

  render() {
    const data = this.getData();

    let artistName = "";
    for (let i = 0; i < data.artist.length; i++) {
      const space = i > 0 ? " & " : "";
      artistName += `${space}${data.artist[i]}`;
    }

    return (
      <div
        className="Modal-bg"
        ref={(node) => {
          this.background = node;
        }}
        onClick={this.onCloseClick}
      >
        <div
          className="ArtistModal"
          ref={(node) => {
            this.container = node;
          }}
        >
          <h2 className="title">{data.title}</h2>
          <p className="artist">{artistName}</p>
          <div
            className="artwork"
            ref={(node) => {
              this.artwork = node;
            }}
          >
            <img alt={data.title} src={data.artwork} />
          </div>
          <p className="description">{data.description}</p>
          <a
            href={`https://hen.teztools.io/objkt/${data.objktID}`}
            target="_blank"
            rel="noreferrer"
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            Hicetnunc Link
          </a>
          <button className="close" onClick={this.onCloseClick}>
            X
          </button>
        </div>
      </div>
    );
  }
}

export default ArtistModal;
